<!--
 * @Author: M.D.
 * @Date: 2019-12-17 15:16:45
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="user">
    <el-row>
      <!-- <el-col :span="20" :offset="2"> -->
      <div class="user-w">
        <!-- left -->
        <div class="inner-w l-wrapper bShadow-5">
          <dl class="sub-list" v-if="menuShow">
            <dt class="sub-t">账号管理</dt>
            <router-link :to="{ name: 'user' }" tag="dd" class="item"
              >个人中心</router-link
            >
            <router-link :to="{ name: 'userInfo' }" tag="dd" class="item"
              >个人信息</router-link
            >
            <router-link :to="{ name: 'invoice' }" tag="dd" class="item"
              >我的发票</router-link
            >
            <router-link :to="{ name: 'message' }" tag="dd" class="item"
              >我的消息</router-link
            >
            <router-link :to="{ name: 'mypoint' }" tag="dd" class="item"
              >我的积分</router-link
            >
            <router-link :to="{ name: 'password' }" tag="dd" class="item"
              >修改密码</router-link
            >
            <router-link :to="{ name: 'recommend' }" tag="dd" class="item"
              >我的推荐</router-link
            >
            <router-link :to="{ name: 'declare' }" tag="dd" class="item"
              >申报信息</router-link
            >
            <router-link :to="{ name: 'risk' }" tag="dd" class="item"
              >风险评估</router-link
            >
          </dl>
          <dl class="sub-list" v-if="menuShow">
            <dt class="sub-t">订单管理</dt>
            <router-link :to="{ name: 'orders' }" tag="dd" class="item"
              >我的订单</router-link
            >
          </dl>
          <dl class="sub-list">
            <dl class="sub-list">
              <dt class="sub-t">帮助中心</dt>
              <router-link :to="{ name: 'qa' }" tag="dd" class="item"
                >常见问题</router-link
              >
            </dl>
          </dl>
        </div>
        <!-- right -->
        <div class="inner-w r-wrapper">
          <!-- <keep-alive :exclude="['user', 'message', 'mypoint', 'recommend']"> -->
          <router-view class="userinfo-content" @openPay="openPay">
            <!-- 勿添加样式 -->
          </router-view>
          <!-- </keep-alive> -->
        </div>
      </div>
      <!-- </el-col> -->
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'userIndex',
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['userInfo']),
    menuShow() {
      return this.userInfo.username && this.userInfo.username.length
    },
  },
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    openPay() {
      this.$emit('openPay')
    },
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.user {
    width:1200px;
   margin: auto;
  // background-color red
  // margin 10px 0 70px
  .user-w {
    display: flex;

    .inner-w {
        width:150px;
      margin: 10px 0;
      height: 100%;
      // background-color red
    }

    .l-wrapper {

      height: 100px;
      background-color: #ffffff;
      min-height: 580px;
      height: 100%;

      .sub-list {
        margin-top: 30px;
        .sub-t {
          width: 100%;
          box-sizing: border-box;
          padding-left: 40px;
          font-size: 18px;
          font-weight: 800;
          height: 40px;
          line-height: 40px;
        }

        .item {
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          font-weight: 400;
          padding-left: 40px;
          &:hover {
            cursor: pointer;
            color: theme-color;
          }

          &.router-link-active {
            color: theme-color;
            padding-left: 35px;
            border-left: 5px solid theme-color;
          }
        }
      }
    }

    .r-wrapper {
      flex: 1 1 auto;
      margin-left: 20px;
      // background-color black
      min-height: 580px;
    }
  }
}
</style>
<style lang="stylus">
.user {
  .userinfo-content {
    // 重置tab样式
    .ui-custom-s {
      .el-tabs__item {
        height: 50px;
        line-height: 50px;
        padding: 0;

        .lb-txt {
          padding: 0 20px;
        }
      }
    }
  }
}
</style>
